module.exports = __webpack_public_path__ + "static/media/my-history.fdce3bdb.png";